/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShowAllLayersIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Show All Layers',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.575 17.83 2.887 10.351c-.241-.123-.241-.323 0-.446l14.688-7.48a.943.943 0 0 1 .85 0L33.113 9.9c.241.123.241.323 0 .446L18.425 17.83a.936.936 0 0 1-.85 0ZM33.114 25.905l-4.6-2.341L18 28.918 7.484 23.564l-4.6 2.341c-.241.123-.241.323 0 .446l14.691 7.479a.936.936 0 0 0 .85 0l14.689-7.479c.24-.123.24-.323 0-.446Z"
    />
    <path
      d="m33.114 17.905-4.6-2.341L18 20.918 7.484 15.564l-4.6 2.341c-.241.123-.241.323 0 .446l14.691 7.479a.936.936 0 0 0 .85 0l14.689-7.479c.24-.123.24-.323 0-.446Z"
    />
  </svg>`;
};
